import{EXPIRE_PRODUCTS_BY_HASH}from"../constants";/**
 * Creates the dispatched EXPIRE_PRODUCTS_BY_HASH action object.
 * @param {string|string[]} hash The hash
 * @returns {Object} The dispatched action object.
 */var expireProductsByHash=function expireProductsByHash(hash){return{type:EXPIRE_PRODUCTS_BY_HASH,hash:hash};};export default expireProductsByHash;